export const LOGIN_REQUEST = 'zola/auth/LOGGED_IN';
export const LOGIN_SUCCESS = 'zola/auth/LOGGED_OUT';
export const LOGIN_FAILURE = 'zola/auth/LOGIN_FAILURE';
export const LOGOUT = 'zola/auth/LOGOUT';
export const ACCOUNT_CREATED = 'zola/account/created';
export const SET_BUSINESS_UNIT = 'zola/auth/SET_BUSINESS_UNIT';



/** WEBPACK FOOTER **
 ** ./src/actions/types/AuthActionTypes.js
 **/